import { render, staticRenderFns } from "./ResultSearchFamilia.vue?vue&type=template&id=3866d006"
import script from "./ResultSearchFamilia.vue?vue&type=script&lang=js"
export * from "./ResultSearchFamilia.vue?vue&type=script&lang=js"
import style0 from "./ResultSearchFamilia.vue?vue&type=style&index=0&id=3866d006&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports